/**
 * Wallet service — balance, transactions, recharge, contact purchases.
 */
import apiClient from './apiClient';

/**
 * Get wallet balance.
 */
export const getWalletBalance = async () => {
    return apiClient.get('/wallet/balance');
};

/**
 * Get transaction history.
 */
export const getWalletTransactions = async (skip = 0, limit = 50) => {
    return apiClient.get(`/wallet/transactions?skip=${skip}&limit=${limit}`);
};

/**
 * Get available coin recharge packages.
 */
export const getCoinPackages = async () => {
    return apiClient.get('/wallet/packages');
};

/**
 * Create Razorpay recharge order.
 */
export const createRechargeOrder = async (amount, coins) => {
    return apiClient.post('/wallet/create-order', { amount, coins });
};

/**
 * Verify Razorpay payment and credit wallet.
 */
export const verifyPayment = async (razorpay_order_id, razorpay_payment_id, razorpay_signature) => {
    const params = new URLSearchParams({
        razorpay_order_id,
        razorpay_payment_id,
        razorpay_signature,
    });
    return apiClient.post(`/wallet/verify-payment?${params.toString()}`);
};

/**
 * Purchase a contact (old flow).
 */
export const purchaseContact = async (sellerId, sellerType) => {
    return apiClient.post(
        `/wallet/purchase-contact?seller_id=${sellerId}&seller_type=${sellerType}`
    );
};

// ==================== Contact Unlock ====================

/**
 * Unlock contact details by paying coins.
 */
export const unlockContact = async (targetType, targetId) => {
    return apiClient.post(
        `/unlock-contact?target_type=${targetType}&target_id=${targetId}`
    );
};

/**
 * Check if a contact has already been purchased.
 */
export const checkPurchaseStatus = async (targetType, targetId) => {
    return apiClient.get(
        `/check-purchase-status?target_type=${targetType}&target_id=${targetId}`
    );
};

/**
 * Check purchase (lighter endpoint).
 */
export const checkPurchase = async (targetType, targetId) => {
    return apiClient.get(
        `/check-purchase?target_type=${targetType}&target_id=${targetId}`
    );
};

/**
 * Get all contacts purchased by current user.
 */
export const getMyPurchasedContacts = async (status = 'all') => {
    return apiClient.get(`/purchased-contacts/my?status=${status}`);
};

/**
 * Get my applications.
 */
export const getMyApplications = async () => {
    return apiClient.get('/applications/my');
};

/**
 * Mark an application/purchase as fulfilled.
 */
export const markApplicationFulfilled = async (applicationId, remarks = '') => {
    const params = remarks ? `?remarks=${encodeURIComponent(remarks)}` : '';
    return apiClient.post(`/applications/${applicationId}/mark-fulfilled${params}`);
};
